import { render } from "./ScWindows.vue?vue&type=template&id=abc10584&scoped=true&ts=true"
import script from "./ScWindows.vue?vue&type=script&lang=ts"
export * from "./ScWindows.vue?vue&type=script&lang=ts"

import "./ScWindows.vue?vue&type=style&index=0&id=abc10584&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/.pnpm/vue-loader@17.3.1_@vue+comp_8f2c4c49f6fda9a4fff749d98711c87c/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abc10584"]])

export default __exports__